import React, { FC } from 'react'

import { Toggle } from '@style-port/roov-ui-components-react'
import { Tooltip, Txt } from 'src/components/atoms'

type Props = {
  disabled?: boolean
  isPublic: boolean
  onChange: (newValue: boolean) => void
  className?: string
}

export const CommonContentReleaseToggle: FC<Props> = ({
  disabled = false,
  isPublic,
  onChange,
  className,
}) => {
  return (
    <div className={className}>
      <div className="tw-centering">
        <Tooltip
          placement="top"
          content={
            <div className="tw-p-s-2">
              <Txt>
                ONにするとすべてのプロジェクトへ配信され、各プロジェクトの
                <br />
                プレゼンツールと、お客様のシェアに表示されるようになります。
              </Txt>
              <Txt className="tw-text-standardText-secondary">
                ※ROOV compass管理画面では閲覧のみ。
              </Txt>
            </div>
          }
        >
          <Txt>プロジェクトへ配信</Txt>
        </Tooltip>

        <Tooltip
          placement="top"
          showIcon={false}
          content={
            isPublic ? (
              <div>
                <Txt>
                  全プロジェクトで<b>表示中</b>
                </Txt>
              </div>
            ) : (
              <div>
                <Txt>
                  全プロジェクトで<b>非表示</b>の状態
                </Txt>
              </div>
            )
          }
        >
          <Toggle
            disabled={disabled}
            enabled={isPublic}
            onChange={onChange}
            className="tw-ml-s-2"
          />
        </Tooltip>
      </div>
    </div>
  )
}
